import TeamsBaseComponent, {ITeamsBaseComponentState} from "msteams-react-base-component";
import {TextField} from "office-ui-fabric-react";
import React = require("react");
import {MetadataFields} from "../../../models";
import {TeamsDocumentStatusTabReorderMetadata} from "./TeamsDocumentStatusTabReorderMetadata";

export interface TeamsDocumentStatusTabTextMetadataState extends ITeamsBaseComponentState {}

export interface TeamsDocumentStatusTabTextMetadataProps {
    metadata: MetadataFields;
    metadataListIndex: number;
    metadataLastListIndex: number;
    shouldReorderMetadata: boolean;
    isMultiline: boolean;
    isResizeable: boolean;
    isDarkMode: boolean;
    setListValueCallback: (value: string, field: string) => void;
    reorderCallback: (metadata: MetadataFields, isDirectionUp: boolean) => void;
}

export class TeamsDocumentStatusTabTextMetadata extends TeamsBaseComponent<
    TeamsDocumentStatusTabTextMetadataProps,
    TeamsDocumentStatusTabTextMetadataState
> {
    constructor(props: TeamsDocumentStatusTabTextMetadataProps) {
        super(props);
    }

    public render() {
        const isDisabled = this.props.metadata.Disabled || this.props.metadata.ManuallyDisabled;

        return (
            <div className={this.props.shouldReorderMetadata ? "metadataWrapper" : ""}>
                <div className={this.props.shouldReorderMetadata ? "metadataField" : ""}>
                    <TextField
                        className={this.props.isDarkMode && isDisabled ? "darkModeLabelDisabled" : ""}
                        disabled={isDisabled}
                        errorMessage={this.props.metadata.ErrorMessage}
                        multiline={this.props.isMultiline}
                        resizable={this.props.isResizeable}
                        required={this.props.metadata.Required}
                        label={this.props.metadata.Field}
                        style={{
                            backgroundColor: this.props.isDarkMode ? "black" : "white",
                            color: this.props.isDarkMode ? "white" : "black",
                        }}
                        value={this.props.metadata.Value}
                        onChange={(_, val) => this.props.setListValueCallback(val, this.props.metadata.Field)}
                    />
                </div>
                <TeamsDocumentStatusTabReorderMetadata
                    metadata={this.props.metadata}
                    shouldReorderMetadata={this.props.shouldReorderMetadata}
                    reorderCallback={this.props.reorderCallback}
                    metadataListIndex={this.props.metadataListIndex}
                    metadataListLastIndex={this.props.metadataLastListIndex}
                />
            </div>
        );
    }
}
